import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FileData {
  cProfileId: string;
  description: string;
  upload: any;
  returnId: string;
  rowIndex: string;
  fileName: string;
  fileType:string;
}
interface FileState {
  files: FileData[];
}

const initialState: FileState = {
  files: [],
};

// Create the slice
const UploadSlice = createSlice({
  name: "MultifileUpload",
  initialState,
  reducers: {
    addFile: (state, action: PayloadAction<FileData>) => {
      
      state.files.push(action.payload);
    
    },
    deleteFile: (state, action: PayloadAction<string>) => {
  
      state.files = state.files?.filter(
        (file) => file.rowIndex !== action.payload
      );
    },
    updateFile: (
      state,
      action: PayloadAction<FileData>
    ) => {
    
      state.files = state.files?.map((file) =>
        file.rowIndex === action.payload.rowIndex
          ? { ...file, ...action.payload }
          : file
      );
    },
    resetFiles:(state)=>{
      state.files=[];
    }
    
  },
});

export const { addFile, deleteFile, updateFile ,resetFiles} = UploadSlice.actions;
// Export the reducer
export default UploadSlice.reducer;
